import React from "react";
import { withFormik } from "formik";
import styled from "styled-components";
import PropTypes from "prop-types";
import Label from "./Label";
import Button from "./Button";
import TextInput from "./TextInput";
import Panel, { PanelHeader, PanelBody } from "./Panel";

const InlineBlock = styled.div`
  padding-bottom: 10px;
  input {
    display: inline-block;
    width: 70%;
    height: 2.553em;
    color: #56666c;
  }
  div.gap {
    display: inline-block;
    width: 5%;
  }
  button {
    width: 25%;
    height: 2.553em;
  }
`;

const form = withFormik({
  mapPropsToValues: (props) => {
    return {
      jobId: props.jobId || "", // je7pn86j290, jenl8t3r553
    };
  },
  handleSubmit: (values, { props: { fetchJobRequest, endpoint } }) => {
    window.history.pushState(
      null,
      "",
      `/jobs/${values.jobId}?endpoint=${endpoint}`
    );
    fetchJobRequest(endpoint, values.jobId);
  },
});

const JobForm = ({
  handleChange,
  handleSubmit,
  values,
  isFetching,
  toggleSideBar,
  showSideBar,
}) => {
  function toggleDisplay() {
    toggleSideBar(!showSideBar);
  }

  return (
    <div>
      <Panel>
        <PanelHeader onClick={toggleDisplay}>
          Route Solution{" "}
          {showSideBar
            ? "(Click here to hide Sidebar)"
            : "(Click here to show Sidebar)"}
        </PanelHeader>
        <PanelBody style={{ display: showSideBar ? "block" : "none" }}>
          <form onSubmit={handleSubmit}>
            <Label>Job ID</Label>
            <InlineBlock>
              <TextInput
                type="text"
                name="jobId"
                placeholder="Enter Job ID."
                onChange={handleChange}
                value={values.jobId}
              />
              <div className="gap" />
              <Button
                title={isFetching ? "Loading" : "Submit"}
                type="submit"
                disabled={isFetching}
              />
            </InlineBlock>
          </form>
        </PanelBody>
      </Panel>
    </div>
  );
};

JobForm.propTypes = {
  fetchJobRequest: PropTypes.func.isRequired,
  isFetching: PropTypes.bool,
  handleChange: PropTypes.func,
  handleSubmit: PropTypes.func,
  values: PropTypes.object,
  toggleSideBar: PropTypes.func.isRequired,
  showSideBar: PropTypes.bool,
};

export default form(JobForm);
